import React from 'react';
import {RequestGoodsMovementType} from '../../types/StoreReportTypes';
import FromDateToDateFilter from './Components/FromDateToDateFilter';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';
import {Form, Formik} from 'formik';
import {useTranslation} from 'react-i18next';
import {monthNow, todayDate} from '../../assets/utils/dateUtils';
type Props = {
	active: boolean;
	handleSubmit: (values: RequestGoodsMovementType) => void;
};
const NowNameTableFilter: React.FC<Props> = ({active, handleSubmit}) => {
	const {t} = useTranslation();
	const initialValues: RequestGoodsMovementType = {
		from_date: monthNow(),
		to_date: todayDate(),
	};
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<Formik initialValues={initialValues} onSubmit={handleSubmit}>
				{({handleSubmit, resetForm}) => (
					<Form onSubmit={handleSubmit}>
						<div className="item-filter__wrapper">
							<FromDateToDateFilter
								toDateFieldName={'to_date'}
								byDateFieldName={'from_date'}
							/>
						</div>
						<div className="item-filter__buttons">
							<LightGreenButton text={t('Застосувати')} type={'submit'} />
							<GreenButton
								text={t('Очистити')}
								type={'button'}
								onClick={resetForm}
							/>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default NowNameTableFilter;
